
import JSMpeg from './jsmpeg.min.js';

export default {
  props: {
    url: {
      type: String,
      required: true
    },

    poster: {
      type: String,
      required: false
    },

    canvasStyle: {
      type: Object
    }
  },

  data: function data() {
    return {
      isEnded: false,
      isPause: true,
      video: null,
      isEstablished: false,
      isLoadCompleted: false
    };
  },
  mounted: function mounted() {
    if (this.url) {
      this.init();
    }
  },
  destroyed: function destroyed() {
    this.video && typeof this.video.destroy === 'function' && this.video.destroy();
    this.video = null;
  },


  methods: {
    init: function init() {
      var _this = this;

      var canvas = this.$refs['ts'];
      this.video = new JSMpeg.Player(this.url, {
        canvas: canvas,
        onSourceCompleted: function onSourceCompleted() {
          _this.isLoadCompleted = true;
        },
        width: canvas.clientWidth,
        height: canvas.clientHeight,
        loop: false,
        poster: this.poster,
        autoplay: false,
        onEnded: function onEnded() {
          _this.isEnded = true;
          _this.isPause = true;
        },
        onPlay: function onPlay() {
          _this.isEnded = false;
          _this.isPause = false;
        },
        onPause: function onPause() {
          _this.isPause = true;
        },
        onSourceEstablished: function onSourceEstablished() {
          _this.isEstablished = true;
        }
      });
    },
    toggle: function toggle() {
      if (!this.video) return;
      if (this.isPause) {
        if (this.isEnded) {
          this.video.currentTime = 0;
        }
        this.video.play();
      } else {
        this.video.stop();
      }
    }
  }
};